import { queryOptions, useQuery } from '@tanstack/react-query';
import uniq from 'lodash/uniq';

import { EntryStatus } from 'chaika-enums';

import { EntryApi } from '@api';

const STALE_TIME_MS = 5 * 60 * 1000;

const normalizeDoctorIds = (doctorIds: string[]): string[] => uniq(doctorIds).sort();

export const draftEntriesKeys = {
    all: ['draftEntries'] as const,
    byDoctors: (doctorIds: string[], excludedAuthorId: string) =>
        [...draftEntriesKeys.all, { doctorIds: normalizeDoctorIds(doctorIds), excludedAuthorId }] as const,
};

export const draftEntriesQueryOptions = (doctorIds: string[], excludedAuthorId: string) => {
    const normalizedDoctorIds = normalizeDoctorIds(doctorIds);

    return queryOptions({
        queryKey: draftEntriesKeys.byDoctors(normalizedDoctorIds, excludedAuthorId),
        queryFn: () =>
            EntryApi.exists({
                doctorId: normalizedDoctorIds.join(),
                excludedAuthorIds: excludedAuthorId,
                statuses: EntryStatus.Draft,
            }),
        enabled: normalizedDoctorIds.length > 0,
        staleTime: STALE_TIME_MS,
        refetchOnWindowFocus: false,
    });
};

export function useHasForeignDraftEntries(doctorIds: string[], excludedAuthorId: string) {
    return useQuery(draftEntriesQueryOptions(doctorIds, excludedAuthorId));
}
